import { Box, Text } from '@betterment/samba-react';
import { StackedProgressBar } from '@betterment/style-closet-react';

import YtdListItem from '../../../FourOhOneKDeferralSettings/components/YtdListItem';
import { currentYear } from '../../../FourOhOneKDeferralSettings/models';
import { toFormattedMoney } from '../../utils';

type DeferralProjectionProps = {
  ytdContribution: number;
  projectedFutureContribution: number;
  projectedTotalContribution: number;
  contributionLimit: number;
};
export const DeferralProjection: React.FC<DeferralProjectionProps> = ({
  ytdContribution,
  projectedFutureContribution,
  projectedTotalContribution,
  contributionLimit,
}) => {
  const formattedYtdContribution = toFormattedMoney(ytdContribution);
  const formattedProjectedFutureContribution = toFormattedMoney(projectedFutureContribution);
  const formattedProjectedTotal = toFormattedMoney(projectedTotalContribution);
  const formattedContributionLimit = toFormattedMoney(contributionLimit);

  let ytdPercent: number;
  let projectedPercent: number;

  const hasExceededLimit = ytdContribution >= contributionLimit;
  if (hasExceededLimit) {
    ytdPercent = 100;
    projectedPercent = 0;
  } else {
    const willExceedLimit = ytdContribution + projectedFutureContribution > contributionLimit;
    if (willExceedLimit) {
      ytdPercent = (ytdContribution / contributionLimit) * 100;
      projectedPercent = 100 - ytdPercent;
    } else {
      ytdPercent = (ytdContribution / contributionLimit) * 100;
      projectedPercent = (projectedFutureContribution / contributionLimit) * 100;
    }
  }

  const contributionPercentages = [
    {
      percent: ytdPercent,
      indicatorColor: 'bmtVizNavy',
    },
    {
      percent: projectedPercent,
      indicatorColor: 'bmtVizBlue50',
    },
  ];

  return (
    <>
      <StackedProgressBar percents={contributionPercentages} />
      <Box css={{ display: 'flex' }}>
        <Text css={{ flexGrow: 1, fontSize: 'fontSize.25' }}>$0</Text>
        <Text css={{ fontSize: 'fontSize.25' }}>{formattedContributionLimit} limit</Text>
      </Box>

      <YtdListItem bullet="bmtVizNavy" leadingTitle="Year-to-date" trailingTitle={formattedYtdContribution} />
      <YtdListItem
        bullet="bmtVizBlue50"
        leadingTitle="Projected"
        trailingTitle={`${formattedProjectedFutureContribution}*`}
        projectionTooltip={true}
      />
      <YtdListItem
        leadingTitle={`Projected ${currentYear()} total`}
        trailingTitle={`${formattedProjectedTotal}*`}
        strong={true}
      />
    </>
  );
};
